// extracted by mini-css-extract-plugin
export default {"mainSection":"MainSection_mainSection__9NA59","mainSection_Card":"MainSection_mainSection_Card__X9wwU"};